import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

function getRemaining(target) {
  const diff = target - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  const d = Math.floor(diff / 86400000);
  const h = Math.floor((diff / 3600000) % 24);
  const m = Math.floor((diff / 60000) % 60);
  const s = Math.floor((diff / 1000) % 60);
  return { d, h, m, s, done: false };
}

const Unit = ({ value, label, testid }) => (
  <div
    className="neon-edge px-3 sm:px-5 py-3 sm:py-4 bg-[#100913]/70 backdrop-blur min-w-[64px] sm:min-w-[88px] text-center"
    data-testid={testid}
  >
    <div className="text-2xl sm:text-4xl font-black text-white tracking-tight tabular-nums">
      {String(value).padStart(2, "0")}
    </div>
    <div className="text-[9px] sm:text-[10px] uppercase tracking-[0.2em] text-[#756B8A] mt-1">
      {label}
    </div>
  </div>
);

export default function Countdown({ targetISO }) {
  const target = targetISO ? new Date(targetISO).getTime() : null;
  const [t, setT] = useState(() => (target ? getRemaining(target) : null));

  useEffect(() => {
    if (!target) return;
    setT(getRemaining(target));
    const id = setInterval(() => setT(getRemaining(target)), 1000);
    return () => clearInterval(id);
  }, [target]);

  if (!target || !t) return null;

  if (t.done) {
    return (
      <div
        className="mt-10 inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-[#B026FF]/45 bg-[#B026FF]/10"
        data-testid="countdown-launched"
      >
        <Sparkles className="w-4 h-4 text-[#B026FF]" />
        <span className="text-sm font-semibold text-white">
          Premiera trwa — sprawdź dostępność modeli
        </span>
      </div>
    );
  }

  return (
    <div className="mt-10" data-testid="countdown-wrapper">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-1.5 h-1.5 rounded-full bg-[#B026FF] pulse-glow" />
        <span className="uppercase tracking-[0.25em] text-[10px] sm:text-[11px] font-semibold text-[#B026FF]">
          Premiera za
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-2 sm:gap-3">
        <Unit value={t.d} label="dni" testid="countdown-days" />
        <span className="text-[#756B8A] text-2xl font-black hidden sm:inline">:</span>
        <Unit value={t.h} label="godz" testid="countdown-hours" />
        <span className="text-[#756B8A] text-2xl font-black hidden sm:inline">:</span>
        <Unit value={t.m} label="min" testid="countdown-minutes" />
        <span className="text-[#756B8A] text-2xl font-black hidden sm:inline">:</span>
        <Unit value={t.s} label="sek" testid="countdown-seconds" />
      </div>
    </div>
  );
}
